<template>    
<div class="card border-0">
  <div class="card-body">

    <div class="row">
      <div class="col-12 col-xl-8 order-2 order-xl-1">

        <div v-if="orgComp == 0" class="row">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style=""/>
            <span class="ml-3 h4" style="color:#0E1698">Loading Organizations...</span>
          </div>
        </div>

        <div v-if="orgComp == 1" class="row">
          <div class="col-12 text-right">
            <a href="#" class="small" @click="createOrg">Add an Organization</a>
          </div>
          <div v-if="orgList.length < 1" class="col-12 text-center">
            <div class="mt-5 h4 text-muted">You have no current organizations.</div>
          </div>
          <div v-if="orgList.length > 0" class="col-12">

            <div class="d-none d-lg-block">
              <v-client-table :data="orgList" :columns="tableColumns" :options="tableOptions">
                <div slot="slot1" slot-scope="props">
                  <a href="#" class="" @click="viewOrg(props.row.id)"><i class="fa fa-search" aria-hidden="true"></i></a>
                </div>
                <div slot="slot2" slot-scope="props">
                  <a href="#" class="text-primary" @click="editOrg(props.row.id)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
                </div>
                <div slot="slot3" slot-scope="props">
                  <a href="#" class="text-danger" @click="deleteOrg(props.row.pivot.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                </div>
              </v-client-table>
            </div>

            <div class="d-block d-lg-none list-group">
              <v-client-table :data="orgList" :columns="tableColumns2" :options="tableOptions2">
                <div slot="slot1"  slot-scope="props" class="list-group-item">
                  <div class="mb-1 text-wrap"><span class="text-muted">Name: </span>{{ props.row.name }}</div>
                  <div class="mb-1 text-wrap"><span class="text-muted">Address: </span>{{ props.row.addr1 }}</div>
                  <div class="mb-2 text-left text-truncate"><span class="text-muted"></span>{{ props.row.city }} {{ props.row.state }}</div>
                  <div class="mb-2 text-left text-truncate"><span class="text-muted"></span>{{ props.row.zip }}</div>
                  <hr>
                  <div class="d-flex justify-content-around">
                    <a href="#" class="" @click="viewOrg(props.row.id)"><i class="fa fa-search" aria-hidden="true"></i></a>
                    <a href="#" class="text-primary" @click="editOrg(props.row.id)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
                    <a href="#" class="text-danger" @click="deleteOrg(props.row.pivot.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                  </div>
                </div>
              </v-client-table>
            </div>


          </div>
        </div>

      </div>
      <div class="col-12 col-xl-4 order-1 order-xl-2">
        <transition name="slide-fade" mode="out-in">
          <component 
              :is="subView" 
              :prop1="svProp1" 
              :prop2="svProp2" 
              :prop3="svProp3" 
              @onSComplete="successComplete" 
              @onUComplete="unsuccessComplete"
              @onSecondary="secondaryAction"
            >
          </component>
        </transition>
      </div>
    </div>

  </div>
</div>
</template>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners' 
import {store} from '../../../stores/settings-user-main-store.js'

import viewOrg from './settings-user-org-view.vue'
import editOrg from './settings-user-org-edit.vue'
import createOrg from './settings-user-org-create.vue'

export default {
  store,
  data: function () {
    return { 
      subView: '',
      svProp1: '',
      svProp2: '',
      svProp3: '',
      tableColumns: ['name', 'addr1', 'city','state', 'slot1', 'slot2', 'slot3'],
      tableOptions: {
        skin: 'table table-sm table-hover border-0 vuetable2',
        filterable: true,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 15,
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: {
          name: '',
          addr1: '',
          city: '',
          state: 'text-center',
          zip: '',
          slot1: 'text-center',
          slot2: 'text-center', 
          slot3: 'text-center',
          
        }, 
        headings: { 
          name: 'Name',
          addr1: 'Address',
          city: 'City',
          state: 'State',
          zip: '',
          slot1: '',
          slot2: '', 
          slot3: '',
        },
      },
      tableColumns2: ['slot1'],
      tableOptions2: {
        skin: 'table table-sm table-hover border-0 vuetable2',
        filterable: true,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 8,
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: {
          slot1: '',
        }, 
        headings: { 
          slot1: '',
        },
      }
    }
  },
  computed: {
    orgList () { return this.$store.state.orgList },
    orgComp () { return this.$store.state.orgComp },
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    getAllUserOrganizations() { this.$store.dispatch("getAllUserOrganizations")  },
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'org-edit':
        _this.getAllUserOrganizations();
        _this.viewOrg(value[1])
        break;
        case 'org-create':
        _this.getAllUserOrganizations();
        _this.svProp1 = '';
        _this.subView = '';
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'org-view':
          _this.svProp1 = '';
          _this.subView = '';
        break;
        case 'org-edit':
          _this.svProp1 = value[1];
          _this.subView = 'org-view';
        break;
        default:
      }
    },
    secondaryAction(value) {
      var _this = this;
      switch(value[0]) {
        case 'org-view':
          _this.svProp1 = value[1];
          _this.subView = 'org-edit';
        break;
        case 'org-edit':
          _this.svProp1 = value[1];
          _this.subView = 'org-view';
        break;
        case 'org-create':
          _this.svProp1 = '';
          _this.subView = '';
        break;
        default:
      }
    },
    createOrg() {
      var _this = this;
      _this.subView = 'org-create';
    },
    viewOrg(x) {
      var _this = this;
      _this.svProp1 = x;
      _this.subView = 'org-view';
      
    },
    editOrg(x) {
      var _this = this;
      _this.svProp1 = x;
      _this.subView = 'org-edit';
    },
    deleteOrg(x) {
      var _this = this;
      _this.$swal.fire({
        title: 'Are you sure?',
        text: "This organization will no longer be available for quotes.",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Remove the Organization',
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#3085d6',
      }).then((result) => {
        if (result.value) {
          axios.get( '/utility/organization/relation/changestatusrel/'+ x +'/1')
          .then(function(response){
            var msg = response.data.msg;
            _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
            _this.getAllUserOrganizations();
          })
          .catch(function(error){
            var errors = error.response.data.errors;
            _this.errorDisplay(errors);
          });
          
        }
      })
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },   
  },    
  components:{
    ScalingSquaresSpinner,
    'org-view' : viewOrg,
    'org-edit' : editOrg,
    'org-create' : createOrg,
  },
  filters: {

  }
}
</script>
